import axios from "axios";

const getTagsDropdown = async () => {
  const response = await axios.get('/serialnumber/api/v1/tags/dropdown-name');

  return response.data;
};

export default getTagsDropdown;